import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Button,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Nav,
  NavItem,
  NavLink
} from "reactstrap";
import UiContent from "../../Components/Common/UiContent";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { useHistory } from "react-router-dom";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { useSelector } from "react-redux";
import CustomPagination from "../../Components/Common/CustomPagination";
import Loader from "../../Components/Common/Loader";

const MenuManagement = () => {
  const [activeCategory, setActiveCategory] = useState("");
  const history = useHistory();
  const [dishes, setDishes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currency, setCurrency] = useState('$');
  const [statusFilter, setStatusFilter] = useState("");
  const [flashCompletedCount, setFlashCompletedCount] = useState(0);
  const [flashInCompletedCount, setFlashInCompletedCount] = useState(0);
  const [classificationData, setClassificationData] = useState([]);
  const { courses, currentOutlet } = useSelector((state) => ({
        courses: state.Dashboard.filterData.courses || [],
        currentOutlet: state.UserOutletGroup.currentOutlet
  }));
  const [addDishModal, setAddDishModal] = useState(false);
  const toggleAddDish = () => setAddDishModal(!addDishModal);
  const [recipeTab, setRecipeTab] = useState("text");

  const [editDishModal, setEditDishModal] = useState(false);
  const [editingDish, setEditingDish] = useState(null);
  const toggleEditDishModal = () => setEditDishModal(!editDishModal);

  const [deleteModal, setDeleteModal] = useState(false);
  const [deletingDish, setDeletingDish] = useState(null);
  const toggleDeleteModal = () => setDeleteModal(!deleteModal);

  const [searchText, setSearchText] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    price: "",
    description: "",
    selling_price: "",
    cost: "",
    type: ""
  });
  useEffect(() => {
    if (currentOutlet?.currency !== "") {
      setCurrency(currentOutlet?.currency);
    }
    fetchClassificationData();
  }, [currentOutlet]);
  const categories = React.useMemo(() => {
    return [{ label: "All", value: "" }, ...(courses || [])];
  }, [courses]);
  // const categories = React.useMemo(() => {
  //   const filteredCourses = (courses || []).filter(
  //     (c) => c.label !== "Kitchen Instructions"
  //   );

  //   return [{ label: "All", value: "" }, ...filteredCourses];
  // }, [courses]);

  
  const [pageCount, setPageCount] = useState(0);
  const [selectedPage, setSelectedPage] = useState(0);

   const courseColorMap = useMemo(() => {
        const map = new Map();
  
        courses.forEach(course => {
            if (course.label) {
                map.set(course.label, {
                    bg: course.badge_bg || null,
                    text: course.badge_text || null,
                });
            }
        });
  
        return map;
    }, [courses]);
  
    /**
     * Get full badge style by label
     */
    const getColorByLabel = (label) => {
        const colorObj = courseColorMap.get(label);
  
        if (!colorObj || !colorObj.bg) {
            return {
              backgroundColor: "#405189",
              color: "#FFFFFF"
            }; // No color assigned
        }
  
        return {
            backgroundColor: colorObj.bg,
            color: colorObj.text || "#000000",
        };
    };

  const handleCategoryClick = (cat) => {
    setActiveCategory(cat.value);
    fetchMenuItems(cat.value, statusFilter, debouncedSearch);
  };

  const handleStatusFilter = (status) => {
    setStatusFilter(status);
    fetchMenuItems(activeCategory, status, debouncedSearch);
  };

  useEffect(() => {
    fetchMenuItems("","",debouncedSearch);
  }, [currentOutlet, selectedPage, debouncedSearch]);

  const fetchMenuItems = (categoryId = "", flashStatus = "", search = "") => {
    setLoading(true);

    postDataAPI({
      serviceName: "item_data",
      op: "server_coaching_outlet_items",
      display_classcification: "Yes",
      type: "Item",
      status: "Active",
      load: selectedPage+1,
      is_show_all: false,
      course_id: categoryId,
      flash_status: flashStatus,
      search: search
    })
      .then((res) => {
        setLoading(false);
        if (res.status === "ok") {
          setDishes(res.data.server_data || []);
          setPageCount(Math.ceil(parseInt(res.data.total_records) / 18));
          setFlashCompletedCount(res.data.total_flash_complete_records);
          setFlashInCompletedCount(res.data.total_flash_incomplete_records);
        }
      });
  };

  const fetchClassificationData = () => {
    postDataAPI({
      serviceName: "classifications_data",
      op: "outlet_type_dropdown"
    })
      .then((res) => {
        if (res.status === "ok") {
          setClassificationData(res.data);
        }
      });
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchText);
    }, 600); // ⏱ debounce delay

    return () => clearTimeout(timer);
  }, [searchText]);


  const handleAddDish = () => {
    if (!formData.name || !formData.price || !formData.type) {
      alert("Dish name, price and type are required");
      return;
    }
    setLoading(true);

    postDataAPI({
      serviceName: "item_data",
      op: "server_coaching_item_create_update",
      dishName: formData.name,
      price: formData.price,
      cost: formData.cost || "",
      selling_price: formData.selling_price || "",
      type: formData.type
    })
      .then((res) => {
        setLoading(false);
        if (res.status === "ok") {
          toggleAddDish(); 
          fetchMenuItems();
          setFormData({
            name: "",
            price: "",
            cost: "",
            selling_price: "",
            type: ""
          });
        } else {
          alert(res.message || "Failed to add dish");
        }
      });
  };

  const handleUpdateDish = () => {
    if (
      !editingDish?.item_name ||
      !editingDish?.price ||
      !editingDish?.OutletType_key
    ) {
      alert("Dish name, price and type are required");
      return;
    }
    setLoading(true);

    postDataAPI({
      serviceName: "item_data",
      op: "server_coaching_item_create_update",
      item_id: editingDish.item_id,
      dishName: editingDish.item_name,
      price: editingDish.price,
      selling_price: editingDish.selling_price || "",
      cost: editingDish.cost || "",
      type: editingDish.OutletType_key
    })
      .then((res) => {
        setLoading(false);
        if (res.status === "ok") {
          toggleEditDishModal();   // close modal
          fetchMenuItems();        // refresh list
        } else {
          alert(res.message || "Failed to update dish");
        }
      });
  };



  return (
    <React.Fragment>
    <UiContent />
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Menu Management" pageTitle="Dashboard &nbsp; > &nbsp; Server Performance Coaching" />

        {/* Top Controls */}
        <Row className="align-items-center mb-3 g-2">
          <Col lg="3">
            <Input
              placeholder="🔍 Search dishes..."
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
                setSelectedPage(0); // reset pagination on search
              }}
            />
          </Col>


          <Col lg="9" className="text-end">
            <Button outline  className="me-2"
                onClick={() => history.push("/server-performance-coaching")}
            >
                ⬅ Back to Home
            </Button>
            <Button color="primary" onClick={toggleAddDish}>
              ＋ Add New Dish
            </Button>
          </Col>
        </Row>

        {/* Category Filters */}
        <Row className="mb-4">
        <Col className="d-flex flex-wrap gap-2 col-7">
          {categories.map((cat) => {
            //const color = categoryColorMap[cat.value];
            const color = "#405189";

            return (
              <Button
                key={cat.value}
                size="sm"
                onClick={() => handleCategoryClick(cat)}
                style={{
                  backgroundColor:
                    activeCategory === cat.value ? getColorByLabel(cat.label).backgroundColor : "transparent",
                  borderColor: getColorByLabel(cat.label).backgroundColor,
                  color:
                    activeCategory === cat.value ? getColorByLabel(cat.label).color : "#000"
                }}
              >
                {cat.label}
              </Button>
            );
          })}
        </Col>

        <Col className="d-flex gap-2 align-items-center col-5 justify-content-end">
          <Badge color="secondary" pill className="p-2">
            ⏱ Incomplete ({flashInCompletedCount})
          </Badge>
          <Badge color="secondary" pill className="p-2">
            ✔ Complete ({flashCompletedCount})
          </Badge>

          <Button
            size="sm"
            color={statusFilter === "" ? "secondary" : "secondary"}
            outline={statusFilter !== ""}
            onClick={() => handleStatusFilter("")}
          >
            All
          </Button>

          <Button
            size="sm"
            color={statusFilter === "Incomplete" ? "secondary" : "secondary"}
            outline={statusFilter !== "Incomplete"}
            onClick={() => handleStatusFilter("Incomplete")}
          >
            Incomplete
          </Button>

          <Button
            size="sm"
            color={statusFilter === "Complete" ? "secondary" : "secondary"}
            outline={statusFilter !== "Complete"}
            onClick={() => handleStatusFilter("Complete")}
          >
            Complete
          </Button>
        </Col>

        </Row>


        {/* Dish Cards */}
        {loading && <Loader />}  
        <Row className={loading ? "opacity-0 g-4 mb-5" : "g-4 mb-5"}>
          {dishes.map(dish => (
            <Col key={dish.item_id} lg="4" md="6">
              <Card className=" h-100">
                <CardBody>
                  {/* Header */}
                  <div className="d-flex justify-content-between">
                    <h6 className="fw-bold mb-1">{dish.item_name}</h6>
                    <div className="fs-5 d-flex gap-0">
                        <i
                          className="ri-edit-box-line text-muted action-icon"
                          title="Edit"
                          onClick={(e) => {
                            console.log(dish);
                            
                            e.stopPropagation();
                            setEditingDish(dish);
                            setEditDishModal(true);
                          }}
                        />
                        <i
                          className="ri-delete-bin-line text-danger action-icon"
                          title="Delete"
                          onClick={(e) => {
                            e.stopPropagation();
                            setDeletingDish(dish);
                            setDeleteModal(true);
                          }}
                        />
                        </div>

                  </div>

                  <div className="mb-2">
                    <Badge
                      className="me-2 badge-course"
                     // style={{ "--badge-color": getColorByLabel(dish.course_name) }}
                      style={{"--badge-color": getColorByLabel(dish.course_name).backgroundColor, "--badge-text": getColorByLabel(dish.course_name).color}}
                      pill
                    >
                      {dish.course_name}
                    </Badge>

                    <span className="text-muted small">
                      · {currency}{dish.price}
                    </span>
                  </div>

                  <p className="text-muted small">
                    {dish.item_description}
                  </p>

                  <Button
                    color={dish.flash_id ? "success" : "secondary"}
                    block
                    onClick={() => {
                      if (dish.flash_id) {
                        history.push(`/flash-cards`);
                      } else {
                        history.push(`/create-flash-card`, { dish, badgeColor: getColorByLabel(dish.course_name) });
                      }
                    }}
                  >
                    {dish.flash_id ? "🎓 Flashcard" : "🎓 Create Flash Card"}
                  </Button>

                </CardBody>
              </Card>
            </Col>
          ))}
          <CustomPagination
            pageCount={pageCount}
            setSelectedPage={setSelectedPage}
          />
        </Row>


        <Modal
          isOpen={addDishModal}
          toggle={toggleAddDish}
          size="lg"
          scrollable
        >
          <ModalHeader toggle={toggleAddDish}>
            Add New Menu Item
          </ModalHeader>

          <ModalBody>
            <Form>
              {/* Dish Name & Price */}
              <Row className="mb-3">
                <Col md="6">
                  <FormGroup>
                    <Label>Dish Name</Label>
                    <Input
                      placeholder="e.g., Today's Special Pasta"
                      value={formData.name}
                      onChange={(e) =>
                        setFormData({ ...formData, name: e.target.value })
                      }
                    />
                  </FormGroup>
                </Col>

                <Col md="6">
                  <FormGroup>
                    <Label>Price</Label>
                    <Input
                      placeholder="e.g., 24"
                      value={formData.price}
                      onChange={(e) =>
                        setFormData({ ...formData, price: e.target.value })
                      }
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md="6">
                  <FormGroup>
                    <Label>Selling Price</Label>
                    <Input
                      placeholder="e.g., 10"
                      value={formData.selling_price}
                      onChange={(e) =>
                        setFormData({ ...formData, selling_price: e.target.value })
                      }
                    />
                  </FormGroup>
                </Col>

                <Col md="6">
                  <FormGroup>
                    <Label>Cost</Label>
                    <Input
                      placeholder="e.g., 24"
                      value={formData.cost}
                      onChange={(e) =>
                        setFormData({ ...formData, cost: e.target.value })
                      }
                    />
                  </FormGroup>
                </Col>
              </Row>

              {/* Course */}
              <Row className="mb-3">
                <Col md="6">
                <FormGroup className="mb-3">
                  <Label>Type</Label>
                  <Input
                    type="select"
                    value={formData.type}
                    onChange={(e) =>
                      setFormData({ ...formData, type: e.target.value })
                    }
                  >
                    <option value="">Select a type</option>
                    {classificationData?.map((c) => (
                      <option key={c.cfv_id} value={c.cfv_id}>
                        {c.cfv_name}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
                </Col>
              </Row>

            </Form>
          </ModalBody>

          <ModalFooter>
            <Button outline onClick={toggleAddDish}>
              Cancel
            </Button>
            <Button color="primary" onClick={handleAddDish} disabled={loading}>
              {loading ? "Saving..." : "Add Dish"}
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={editDishModal}
          toggle={toggleEditDishModal}
          centered
        >
          <ModalHeader toggle={toggleEditDishModal}>
            Edit Dish
            <p className="text-muted small mb-0">
              Update the details of your dish
            </p>
          </ModalHeader>

          <ModalBody>
            {/* Dish Name */}
            <FormGroup>
              <Label>Dish Name</Label>
              <Input
                type="text"
                value={editingDish?.item_name || ""}
                onChange={(e) =>
                  setEditingDish({
                    ...editingDish,
                    item_name: e.target.value
                  })
                }
              />
            </FormGroup>

            {/* Price */}
            <FormGroup>
              <Label>Price</Label>
              <Input
                type="text"
                value={`${editingDish?.price || ""}`}
                onChange={(e) =>
                  setEditingDish({
                    ...editingDish,
                    price: e.target.value
                  })
                }
              />
            </FormGroup>

            <FormGroup>
              <Label>Selling price</Label>
              <Input
                type="text"
                value={`${editingDish?.selling_price || ""}`}
                onChange={(e) =>
                  setEditingDish({
                    ...editingDish,
                    selling_price: e.target.value
                  })
                }
              />
            </FormGroup>

            <FormGroup>
              <Label>Cost</Label>
              <Input
                type="text"
                value={`${editingDish?.cost || ""}`}
                onChange={(e) =>
                  setEditingDish({
                    ...editingDish,
                    cost: e.target.value
                  })
                }
              />
            </FormGroup>

            {/* Description */}
            <FormGroup>
              <Label>Type</Label>
              <Input
                type="select"
                value={`${editingDish?.OutletType_key || ""}`}
                onChange={(e) =>
                  setEditingDish({
                    ...editingDish,
                    OutletType_key: e.target.value
                  })
                }
              >
                <option value="">Select a type</option>
                {classificationData?.map((c) => (
                  <option key={c.cfv_id} value={c.cfv_id}>
                    {c.cfv_name}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </ModalBody>

          <ModalFooter>
            <Button outline onClick={toggleEditDishModal}>
              Cancel
            </Button>

            <Button
              color="primary"
              onClick={handleUpdateDish}
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Changes"}
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={deleteModal}
          toggle={toggleDeleteModal}
          centered
          size="md"
        >
          <ModalBody className="p-4">
            <h5 className="fw-semibold mb-2">
              Delete {deletingDish?.item_name}?
            </h5>

            <p className="text-muted mb-4">
              This action cannot be undone. This will permanently delete the dish
              and any associated training data.
            </p>

            <div className="d-flex justify-content-end gap-2">
              <Button outline onClick={toggleDeleteModal}>
                Cancel
              </Button>

              <Button color="danger">
                Delete
              </Button>
            </div>
          </ModalBody>
        </Modal>


      
      </Container>
    </div>
    </React.Fragment>
  );
};

export default MenuManagement;
